<div class="FacturasFrame">
    <iframe id="iframeTuf" class="FacturasIframe" name="centro"
        src="https://ventas.tufesa.com.mx/apw3/tufesa_es/SolicitarFactura.aspx" frameBorder="0">
    </iframe>
</div>

